import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.items),function(chip,i){return _c(VChip,{key:chip,staticClass:"chips__choice",class:chip == _vm.value ? 'chips__choice--checked' : null,attrs:{"id":'chip' + i,"disabled":!!_vm.disabled,"label":"","ripple":false},on:{"click":function($event){return _setup.updateValue(chip)}}},[_vm._v(" "+_vm._s(chip)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }